import * as React from "react";

interface IProps {
    label: string;
    name: string;
    value: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    required?: boolean;
    maxLength?: number;
    className?: string;
    inputClassName?: string;
}

export class TextInput extends React.Component<IProps> {
    constructor(props: IProps) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    public render() {
        const {
            label,
            name,
            value,
            required = false,
            maxLength,
            className = "mb-3",
            inputClassName = "form-control w-100"
        } = this.props;

        return (
            <div className={className}>
                <label htmlFor={name} className="form-label">{label}</label>
                <input
                    type="text"
                    id={name}
                    name={name}
                    value={value}
                    onChange={this.handleChange}
                    maxLength={maxLength}
                    required={required}
                    className={inputClassName}
                />
            </div>
        );
    }

    protected handleChange(event: React.ChangeEvent<HTMLInputElement>) {
        this.props.onChange(event);
    }
}
